import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTranslation } from "react-i18next";
export const ThemeToggle = ({ theme, onToggle }) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onToggle}
      className="gpc-header-button gpc-focus-visible gpc-transition"
      aria-label={t("theme.toggle")}
      title={t("theme.toggle")}
    >
      {theme === "light" ? (
        <Moon className="gpc-icon" />
      ) : (
        <Sun className="gpc-icon" />
      )}
    </button>
  );
};